export const getToken = () => {
  const token = sessionStorage.getItem('token');
  return token || '';
};

export const getRole = () => {
  const role = sessionStorage.getItem('role');
  return role || '';
};
